import { render, staticRenderFns } from "./PersonaMiniCard.vue?vue&type=template&id=9d20a812&scoped=true&"
import script from "./PersonaMiniCard.vue?vue&type=script&lang=js&"
export * from "./PersonaMiniCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonaMiniCard.vue?vue&type=style&index=0&id=9d20a812&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d20a812",
  null
  
)

export default component.exports